module.exports = __webpack_public_path__ + "static/media/backgroundImg.0f2cee98.png";


//////////////////
// WEBPACK FOOTER
// ./src/less/backgroundImg.png
// module id = 547
// module chunks = 0